import { lastDays } from './dateRanges';
import type { ReportParams } from './types';

// Mirrors AISafety.features; the controller whitelists the value and echoes what it used.
export const FEATURE_LABELS: Record<string, string> = { question_builder: 'Question Builder' };
export const DEFAULT_FEATURE = 'question_builder';
// Mirrors DEFAULT_DAYS on Admin::AISafetyReportsController.
export const DEFAULT_DAYS = 30;

export const reportParamsFrom = (searchParams: URLSearchParams): ReportParams => {
  const defaults = lastDays(DEFAULT_DAYS);
  const subscriberId = searchParams.get('subscriber_id') || undefined;

  return {
    feature: searchParams.get('feature') || DEFAULT_FEATURE,
    from: searchParams.get('from') || defaults.from,
    to: searchParams.get('to') || defaults.to,
    ...(subscriberId && { subscriberId }),
  };
};

// The controller's query params, for both the page URL and the JSON/CSV requests.
export const toQueryParams = ({
  feature, from, subscriberId, to,
}: ReportParams): Record<string, string> => ({
  feature,
  from,
  to,
  ...(subscriberId && { subscriber_id: subscriberId }),
});

export const checkLabel = (name: string) => name.charAt(0).toUpperCase() + name.slice(1).replace(/_/g, ' ');

export const formatRate = (rate: number) => `${rate.toFixed(2)}%`;
